import { render } from "./EmailView.vue?vue&type=template&id=60e61d2c&scoped=true"
import script from "./EmailView.vue?vue&type=script&lang=js"
export * from "./EmailView.vue?vue&type=script&lang=js"

import "./EmailView.vue?vue&type=style&index=0&id=60e61d2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e61d2c"]])

export default __exports__